import env from './env';
// export const PATH = '/';
export const PATH = `/campeonatos/${env.CAMPEONATO.toLocaleLowerCase()}/`;
export const LANDING = PATH;
export const SELECAO = `${PATH}selecao`;
export const ENTRAR = `${PATH}entrar`;
export const ESQUECI = `${PATH}esqueci`;
export const CADASTRAR = `${PATH}cadastrar`;
export const JOGADORES = `${PATH}jogadores`;
